import apiClient from '../../apiClient';

// 요청 타입 (lastId를 쿼리 파라미터로 전달)
export type ReqGetHomePlannings = {
  lastId?: number;
};

// 응답 타입
export type ResGetHomePlannings = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: {
    id: number;
    createdAt: string;
    platformType: string;
    villageName: string;
    categoryId: string;
    categoryName: string;
    marketProductName: string;
    approvalStatus: string;
    businessName: string;
    originPrice: number;
    price: number;
    discountRate: number;
    thumbnailUrl: string;
    deliveryFee: number;
    isDeliveryFree: boolean;
    tagList: string[];
    label: string;
    state: string;
    isPickUp: boolean;
    stockAvailable: number;
    reviewRate: number;
  }[];
};

// API 호출 함수
const getHomePlannings = async (query: ReqGetHomePlannings): Promise<ResGetHomePlannings> => {
  // URLSearchParams를 사용해 쿼리 문자열 생성
  const params = new URLSearchParams();
  if (query.lastId !== undefined) {
    params.append('lastId', query.lastId.toString());
  }

  // API 호출
  const { data } = await apiClient.get<ResGetHomePlannings>(
    `/app/market-products/special-exhibition/random?${params.toString()}&platformType=GROUND`
  );

  return data;
};

export default getHomePlannings;
